module.exports = __webpack_public_path__ + "img/monterey-pulley-blue-large.11db4fb3.png";